
import Vue from 'vue'
import { formaterDecimalBRServer } from '@/utilities/Utils';
import i18n from '@/locales/_i18n';

const getDefaultState = () => {
    return {
        cambio: {
            id: 0,
            descricao: "",
            codigoMoeda: "",
            valor: 0
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("cambio/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listCambio = result.data.result;

                return listCambio;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar cambios: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`cambio/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter cambio`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Erro ao obter cambio: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, cambioRequest) {

        try {
            cambioRequest.valor = formaterDecimalBRServer(cambioRequest.valor);
            cambioRequest.valorDolar = formaterDecimalBRServer(cambioRequest.valorDolar);
            const result = await Vue.prototype.$spTechApi.post(`cambio/create-update`, cambioRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Registro atualizado com sucesso!";

                if (cambioRequest.id === 0) {
                    msg = "Registro criado com sucesso!";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}`
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error}]`
                };
            }
        }
    }
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.marca, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.marca;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
